import cover1 from "../assets/cover1.svg";
import cover2 from "../assets/cover2.svg";
import cover3 from "../assets/cover3.svg";
import cover4 from "../assets/cover4.svg";
import cover5 from "../assets/cover5.svg";
import cover6 from "../assets/cover6.svg";
import cover7 from "../assets/cover7.svg";
import cover8 from "../assets/cover8.svg";
import cover9 from "../assets/cover9.svg";
import cover10 from "../assets/cover10.svg";

const bookList = {
  book1: {
    cover: cover1,
    id: 1,
    title: "Ariol chante comme un rossignol",
    author: "Guibert Emmanuel",
    editor: "BD kids",
    publicationDate: "2023",
    description: "Ariol adore les chansons mais il ne s'attendait pas à ce que Bisbille lui en écrive une. Elle s'appelle Hoquet chorale. Il va falloir l'interpréter avec tous les élèves, devant les parents... Ariol doit faire semblant d'avoir le hoquet hic... hoc... hic... hoc... Comme si c'était facile d'avoir le hoquet et de chanter en même temps !",
    availableCopiesNumber: 1,
    documentType: "Bandes dessinées",
    language: "Français",
    serie: "Ariol, Tome 19",
    section: "Jeunesse",
    physicalAspect: "1 vol. (124 p.) ill. en coul.couv.ill.en coul.",
    contributors: "Chaurand. Rémi (1970 - ) Technicien graphique",
    isbn: "979-10-363-5888-3",
    ean: "9791036358883",
    popularity: "Document emprunté 21 fois ces 6 derniers mois",
  },
  book2: {
    cover: cover2,
    id: 2,
    title: "Ariol vieux sac à puces !",
    author: "Guibert Emmanuel",
    editor: "BD kids",
    publicationDate: "2022",
    description: "Pour l'album d'Ariol numéro 18, faisons la fête a Dix-huit, le chien de Papi Atole et Mamie Annette. Viens ici, mon chien ! Viens ! Dix-huit ! Au pied ! Donne la papatte ! Allez ! Donne la papatte ! Rapporte le bâton ! Fais le beau ! Euh... non. Excusez-le. Il ne veut rien faire de tout ça. Il obéit à un seul ordre, avant même qu'on le lui demande : « Couché ! »",
    availableCopiesNumber: 0,
    documentType: "Bande Dessinée",
    language: "Français",
    serie: "Ariol, 18",
    section: "Jeunesse",
    physicalAspect: "1 vol. (124 p.) ill. en coul.",
    contributors: "Chaurand, Rémi (1970-....). Technicien graphique",
    isbn: "979-10-363-5000-9",
    ean: "9791036350009",
    popularity: "Document emprunté 30 fois ces 6 derniers mois",
  },
  book3: {
    cover: cover3,
    id: 3,
    title: "Ariol la chouette classe verte",
    author: "Guibert Emmanuel",
    editor: "BD kids",
    publicationDate: "2021",
    description: "Ariol est tout excité de partir en classe verte à Fandechiche avec Monsieur Le Bount. Accompagnés par la chauffeuse Madame Ruffec et l'animatrice Bonnie, les journées sont bien remplies. Même si tout ne se passe pas comme prévu, notamment avec Batégaille comme binôme pour le cours de voile, Ariol compte bien profiter de ces quelques jours au vert et peut-être séduire enfin Pétula pendant la boum.",
    availableCopiesNumber: 3,
    documentType: "Bande Dessinée",
    language: "Français",
    serie: "Ariol, 17",
    section: "Jeunesse",
    physicalAspect: "1 vol. (124 p.) ill. en coul.",
    contributors: "Boutavant, Marc (1970-....). Illustrateur",
    isbn: "979-10-363-2888-6",
    ean: "9791036328886",
    popularity: "Document emprunté 26 fois ces 6 derniers mois",
  },
  book4: {
    cover: cover4,
    id: 4,
    title: "Ariol Naphtaline nous dit toutou",
    author: "Guibert Emmanuel",
    editor: "BD kids",
    publicationDate: "2020",
    description: "Entre les concerts du chevalier cheval, les visites chez le psychologues Percheron, la découverte du nouveau magasin bio. Ariol n'a pas le temps de s'ennuyer ! Toujours accompagné de son fidèle ami Ramono, toujours secrètement amoureux de Petula et toujours aussi têtu, l'âne bleu préféré des jeunes lecteurs peut compter sur sa bande de copains pour l'aider dans toutes les situations !",
    availableCopiesNumber: 2,
    documentType: "Bande Dessinée",
    language: "Français",
    serie: "Ariol, 16",
    section: "Jeunesse",
    physicalAspect: "1 vol. (124 p.) ill. en coul.",
    contributors: "Boutavant, Marc (1970-....). Illustrateur",
    isbn: "979-10-363-2371-3",
    ean: "9791036323713",
    popularity: "Document emprunté 47 fois ces 6 derniers mois",
  },
  book5: {
    cover: cover5,
    id: 5,
    title: "Ariol touche pas à mon veau",
    author: "Guibert Emmanuel",
    editor: "BD kids",
    publicationDate: "2019",
    description: "Trois grands de CM2 embêtent Pouyastruc, parce que Pouyastruc préfère jouer avec les filles qu'avec les garçons. Et alors ? Si ça lui plaît ? Il ne fait de mal à personne ! Les CM2, par contre, ils lui en font, du mal. Ils l'attendent tous les matins à l'arrêt du bus devant la boulangerie pour le bousculer et lui dire des choses méchantes. Heureusement Bisbille, Naphtaline, Crouline et Ariol défendent leur copain Poupouille !",
    availableCopiesNumber: 4,
    documentType: "Bande Dessinée",
    language: "Français",
    serie: "Ariol, 15",
    section: "Jeunesse",
    physicalAspect: "1 vol. (124 p.) ill. en coul.",
    contributors: "Chaurand, Rémi (1970-....). Technicien graphique",
    isbn: "979-10-363-1274-8",
    ean: "9791036312748",
    popularity: "Document emprunté 33 fois ces 6 derniers mois",
  },
  book6: {
    cover: cover6,
    id: 6,
    title: "Ariol ce nigaud d'agneau",
    author: "Guibert Emmanuel",
    editor: "BD kids",
    publicationDate: "2018",
    description: "Pharamousse est encore absent. Qu'est-ce qui le défrise, cette fois-ci ? A-t-il un mouton de fièvre ? La laine chargée ? S'est-il cassé une côtelette ? Fait-il son angine du mois de mêêêê ? On a besoin d'un volontaire pour lui apporter les devoirs. Voyons, voyons...qui se dévoue ? Toi, Ariol ?",
    availableCopiesNumber: 3,
    documentType: "Bande Dessinée",
    language: "Français",
    serie: "Ariol, 14",
    section: "Jeunesse",
    physicalAspect: "1 vol. (128 p.) ill. en coul., couv.",
    contributors: "Boutavant, Marc (1970-....). Auteur",
    isbn: "979-10-363-0338-8",
    ean: null,
    popularity: "Document emprunté 37 fois ces 6 derniers mois",
  },
  book7: {
    cover: cover7,
    id: 7,
    title: "Ariol le canard calé",
    author: "Guibert Emmanuel",
    editor: "BD kids",
    publicationDate: "2017",
    description: "Kwax, un caneton musicien et copain de classe d'Ariol, déclenche chez lui une démangeaison musicale. Cependant, Ariol trouve que cela demande trop de travail. Ramono, lui, préfère les crêpes au sucre. Ce treizième album d'Ariol, illustré par Marc Boutavant, continue de dépeindre avec tendresse et humour le quotidien d'un enfant de 9 ans, avec des personnages comme Ramono, Bisbille et Pétula. La magie d'Ariol opère toujours !",
    availableCopiesNumber: 2,
    documentType: "Bande Dessinée",
    language: "Français",
    serie: "Ariol, 13",
    section: "Jeunesse",
    physicalAspect: "1 vol. (124 p.) ill. en coul.",
    contributors: "Boutavant, Marc (1970-....). Illustrateur",
    isbn: "978-2-7470-8601-1",
    ean: "9782747086011",
    popularity: "Document emprunté 31 fois ces 6 derniers mois",
  },
  book8: {
    cover: cover8,
    id: 8,
    title: "Ariol le coq sportif",
    author: "Guibert Emmanuel",
    editor: "BD kids",
    publicationDate: "2017",
    description: "Allez, allez, les enfants ! On se bouge, effectivement ! C'est l'heure de faire du sport avec monsieur Ribéra, effectivement ! La véritable épreuve, c'est que monsieur Ribéra va dire « effectivement » tous les deux mots ! Mais gare à ceux qui se moquent, il les fait cuire à la coque ! Effec-Ti-Ve-Ment !",
    availableCopiesNumber: 6,
    documentType: "Bande Dessinée",
    language: "Français",
    serie: "Ariol, 12",
    section: "Jeunesse",
    physicalAspect: "1 vol. (124 p.) ill. en coul. couv.",
    contributors: "Boutavant, Marc (1970-....). Auteur",
    isbn: "978-2-7470-7253-3",
    ean: null,
    popularity: "Document emprunté 30 fois ces 6 derniers mois",
  },
  book9: {
    cover: cover9,
    id: 9,
    title: "Ariol la fête à la grenouille",
    author: "Guibert Emmanuel",
    editor: "BD kids",
    publicationDate: "2016",
    description: "Pourquoi Ariol offre-t-il une bouteille de bain moussant parfumé à Vanesse, la petite grenouille un peu timide de sa classe ? Ça n'a l'air de plaire ni à Ramono, ni à Pétula. Et si c'était une idée de BiSBiLLE ? Pour avoir la clef de tous ces mystères, venez faire la fête à la grenouille !",
    availableCopiesNumber: 3,
    documentType: "Bande Dessinée",
    language: "Français",
    serie: "Ariol, 11",
    section: "Jeunesse",
    physicalAspect: "1 vol. (124 p.) couv. ill. en coul.",
    contributors: "Boutavant, Marc (1970-....). Auteur",
    isbn: "978-2-7470-5937-4",
    ean: null,
    popularity: "Document emprunté 35 fois ces 6 derniers mois",
  },
  book10: {
    cover: cover10,
    id: 10,
    title: "Ariol les petits rats de l'opéra",
    author: "Guibert Emmanuel",
    editor: "BD kids",
    publicationDate: "2015",
    description: "Et si on dansait ? Les filles ! Les garçons ! Les ânes, les cochons ! Même monsieur Le Blount, l'instituteur, se joint à la farandole et danse comme un chien fou ! Mais le plus incroyable, c'est que Pétula est dans les bras d'Ariol ! La danse, ça change tout !",
    availableCopiesNumber: 4,
    documentType: "Bande Dessinée",
    language: "Français",
    serie: "Ariol, 10",
    section: "Jeunesse",
    physicalAspect: "1 vol. (124 p.) ill. en coul.",
    contributors: "Boutavant, Marc (1970-....). Illustrateur",
    isbn: "978-2-7470-5299-3",
    ean: null,
    popularity: "Document emprunté 26 fois ces 6 derniers mois",
  },
};

export default bookList;
